import { loadData } from "./dataLoader";

let originData;

loadData("journey.json").then((data) => (originData = data));

const subjugationName = {
    "약탈자 토벌 의뢰": "레이더스 인카운터 승리",
    "슬라임 토벌 의뢰": "슬라포칼립스 승리",
    "탈영병 토벌 의뢰": "런 어 웨이 솔저스 승리",
};
const getJourneyEventByName = (name) => {
    if (name.startsWith("미편성")) return;
    else if (name === "아르카나 이벤트") return "아르카나";
    else if (name === "날씨") return "날씨";
    else if (subjugationName[name]) return originData[subjugationName[name]];

    return originData[name];
};

const getWeatherEvents = () => {
    return Object.keys(originData)
        .filter((e) => e.startsWith("오늘의 날씨"))
        .map((e) => originData[e]);
};

export { getJourneyEventByName, getWeatherEvents };
